export default __webpack_public_path__ + "static/media/logo.7cf4eab0.svg";